{
    "locale": "sk-SK",
    "General": {
        "OrText": "Alebo",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Prejsť na My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Vytvoriť nový účet",
        "ButtonText_SignInToYourAccount": "Prihlásiť sa do účtu",
        "ButtonText_StartInterviewWithoutSigningUp": "Začať pohovor bez registrácie",
        "ButtonText_StartInterviewWithoutSigningIn": "Začať pohovor bez prihlásenia",
        "Navlink_Dashboard": "Nástenka",
        "Navlink_MyInterviews": "Moje pohovory",
        "Navlink_LearnWithHubert": "Uč sa s Hubertom",
        "Navlink_HelpCenter": "Centrum pomoci",
        "MyProfile": "Môj profil",
        "LogOut": "Odhlásiť sa"
    },
    "Login": {
        "MainTitle": "Chcete vidieť výsledky svojho pohovoru s Hubertom?",
        "Subtitle": "Prihláste sa, aby ste videli výsledky, dostali spätnú väzbu, prečítali si rady a oveľa viac!",
        "LoginTitle": "Prihláste sa do svojho účtu Hubert",
        "Label_Email": "E-mail",
        "Label_Password": "Heslo",
        "ButtonText_SignIn": "Prihlásiť sa",
        "ButtonText_ForgotPassword": "Zabudnuté heslo?",
        "ButtonText_ContinueWithGoogle": "Pokračovať cez Google",
        "OrSeparator": "Alebo",
        "Error_Email_Required": "E-mail je povinný.",
        "Error_Email_Invalid": "Zadajte platný e-mail.",
        "Error_Password_Required": "Heslo je povinné.",
        "Error_Use_Same_Email_As_Interview": "Použite rovnaký e-mail, ktorý ste uviedli v pohovore."
    },
    "Registration": {
        "MainTitle": "Chcete vidieť výsledky svojho pohovoru s Hubertom?",
        "Subtitle": "Zaregistrujte sa, aby ste videli výsledky, dostali spätnú väzbu, prečítali si rady a oveľa viac!",
        "RegistrationTitle": "Vytvoriť účet Hubert",
        "BenefitsBox_Title": "Môžete",
        "BenefitsBox_Point1": "Získať prístup k histórii pohovorov",
        "BenefitsBox_Point2": "Získať spätnú väzbu na vaše pohovory",
        "BenefitsBox_Point3": "Znovu použiť odpovede v nových pohovoroch",
        "BenefitsBox_Point4": "Získať rady k pohovorom",
        "BenefitsBox_Point5": "Čítať kariérne príručky",
        "BenefitsBox_Point6": "A oveľa viac",
        "Label_FirstName": "Meno",
        "Label_LastName": "Priezvisko",
        "Label_Email": "E-mail",
        "Label_Password": "Heslo",
        "Label_PhoneNumber": "Telefónne číslo",
        "Label_TermsOfService": "Súhlasím s",
        "Label_TermsOfServiceLink": "Zásadami ochrany osobných údajov a Obchodnými podmienkami",
        "Placeholder_CountryCode": "Vyberte predvoľbu",
        "Placeholder_PhoneNumber": "Napr.0901234567",
        "HelpText_Password": "Heslo musí mať aspoň 6 znakov.",
        "ButtonText_SignUp": "Zaregistrovať sa",
        "ButtonText_SignUpWithGoogle": "Zaregistrovať sa cez Google",
        "OrSeparator": "Alebo",
        "Error_FirstName_Required": "Meno je povinné.",
        "Error_LastName_Required": "Priezvisko je povinné.",
        "Error_Email_Required": "E-mail je povinný.",
        "Error_Email_Invalid": "Zadajte platný e-mail.",
        "Error_Email_Exists": "E-mail je už obsadený.",
        "Error_Password_Required": "Heslo je povinné.",
        "Error_Password_6_Characters": "Heslo musí mať aspoň 6 znakov.",
        "Error_PhoneNumber_Required": "Telefónne číslo je povinné.",
        "Error_PhoneNumber_Invalid": "Telefónne číslo nie je platné.",
        "Error_PrivacyPolicyCheck_Required": "Je potrebné prijať Zásady ochrany osobných údajov a Obchodné podmienky."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Aby ste mohli absolvovať pohovor, stačí prijať podmienky používania Huberta. Zaškrtnite políčko pre pokračovanie.",
        "Subtitle_AfterInterviewCompleted": "Zaregistrujte sa, aby ste videli výsledky, dostali spätnú väzbu, prečítali si rady a oveľa viac!",
        "PrivacyPolicyText": "Stlačením zaregistrovať sa súhlasíte s",
        "PrivacyPolicyLink": "Zásadami ochrany osobných údajov a Obchodnými podmienkami",
        "ButtonText_SignUp": "Zaregistrovať sa a prejsť na pohovor",
        "ButtonText_SignUpNormal": "Zaregistrovať sa",
        "ButtonText_SignInInstead": "Kliknite sem pre prihlásenie"
    },
    "LoginInviteEmail": {
        "Subtitle": "Prihláste sa, aby ste videli výsledky, dostali spätnú väzbu, prečítali si rady a oveľa viac!"
    },
    "AppMessages": {
        "internal-server-error": "Nastala neočakávaná chyba.",
        "invalid-credentials": "Neplatné prihlasovacie údaje. Skúste znova.",
        "user-not-found": "Neplatné prihlasovacie údaje. Skúste znova.",
        "account-not-found": "Neplatný účet. Skúste znova.",
        "verify-email-title": "Overte svoj e-mail",
        "verify-email-subtitle": "Skontrolujte svoj e-mail a overte svoj účet.",
        "email-not-verified-title": "E-mail nie je overený",
        "email-not-verified-subtitle": "Skontrolujte svoj e-mail a overte svoj účet.",
        "verifying-email-title": "Overovanie e-mailu",
        "verifying-email-subtitle": "Prosím čakajte...",
        "sign-in-title": "Prihlasovanie",
        "sign-in-subtitle": "Prosím čakajte...",
        "server-error": "Niečo sa pokazilo.",
        "hubert-user-exists": "Účet už existuje.",
        "account-exists": "Účet už existuje.",
        "email-verified": "Váš e-mail bol overený.",
        "email-is-taken": "E-mail je už obsadený.",
        "re-enter-password": "Prihláste sa pomocou hesla",
        "password-reset": "Vaše heslo bolo zmenené.",
        "re-enter-new-password": "Prihláste sa pomocou nového hesla",
        "invalid-invitation": "Neplatná pozvánka.",
        "invalid-code": "Neplatný overovací kód.",
        "email-already-verified": "E-mail je už overený.",
        "email-mismatch-title": "Nezhoda e-mailu",
        "email-mismatch-subtitle": "Použite rovnakú e-mailovú adresu, ktorú ste použili pri žiadosti o prácu."
    },
    "TransitionPage": {
        "loading-title": "Načítavam...",
        "loading-subtitle": "Pripravujeme vaše údaje...",
        "logout-title": "Načítavam...",
        "logout-subtitle": "Odhlasujeme vás..."
    },
    "ImpersonationPage": {
        "loading-title": "Načítavam...",
        "loading-subtitle": "Pripravujeme vaše údaje..."
    },
    "ProcessInvitation": {
        "loading-title": "Načítavam...",
        "loading-subtitle": "Chvíľku strpenia, načítavame váš pohovor.",
        "InvitationNotFound": "Váš pohovor nevieme nájsť.",
        "InvitationExpired": "Tento odkaz na pohovor vypršal.",
        "InvitationExpired_Description1": "Otvorte pohovor z",
        "InvitationExpired_Description2": "alebo kontaktujte svojho náborára.",
        "InvitationInvalid": "Odkaz na túto pozvánku je neplatný.",
        "InterviewCompleted": "Tento pohovor už bol dokončený."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Moje pohovory",
            "TableHead_Employer": "Zamestnávateľ",
            "TableHead_Job": "Pozícia",
            "TableHead_Status": "Stav",
            "TableHead_ApplicationDate": "Dátum prihlášky",
            "TableBody_StartInterview": "Pohovor nie je dokončený. Kliknite sem pre spustenie alebo pokračovanie.",
            "TableBody_NotScored": "Pohovor je ukončený. Výsledky budú čoskoro k dispozícii.",
            "TableBody_Details": "Kliknite sem pre zobrazenie výsledkov a ďalších informácií.",
            "ApplicationDate_Invited": "Pozvaný",
            "ApplicationDate_MinuteAgo": "pred minútou",
            "ApplicationDate_MinutesAgo": "pred minútami",
            "ApplicationDate_HourAgo": "pred hodinou",
            "ApplicationDate_HoursAgo": "pred hodinami",
            "ApplicationDate_DayAgo": "pred dňom",
            "ApplicationDate_DaysAgo": "pred dňami",
            "ButtonText_SeeAllInterviews": "Zobraziť všetky pohovory",
            "ButtonText_Details": "Detaily",
            "ButtonText_StartInterview": "Prejsť na pohovor",
            "ButtonText_NotScored": "Čakajúce výsledky",
            "NoInterviews_Message": "Nemáte žiadne záznamy o minulých ani nadchádzajúcich pohovoroch."
        },
        "LatestJobPostings": {
            "NoJobPostings": "V súčasnosti nie sú žiadne pracovné ponuky. Skúste to znova neskôr."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Moja kariéra",
            "Subtitle": "Vyberte pohovor pre zobrazenie hodnotenia a vašich vyhliadok.",
            "MostRecentInterview": "Najnovší pohovor",
            "ToDo": "Na vybavenie",
            "NoOngoingInterviews_Title": "Nemáte žiadne nové pozvánky na pohovor.",
            "NoOngoingInterviews_Subtitle": "Nové Hubert pohovory sa zobrazia tu, keď ich naplánujú náborári.",
            "NoRecentInterviews_Title": "Nemáte žiadny záznam o predchádzajúcom pohovore.",
            "NoRecentInterviews_Subtitle": "Keď vás náborári pozvú na pohovor, zobrazí sa nižšie.",
            "ButtonText_StartInterview": "Prejsť na pohovor",
            "ButtonText_NotScored": "Čakajúce výsledky",
            "ButtonText_Details": "Podrobnosti"
        },
        "LearnWithHubert": {
            "Title": "Uč sa s Hubertom",
            "Subtitle": "Získaj rady, ako sa zlepšiť v pohovoroch a v práci.",
            "PickedForMe": "Najnovšie články",
            "ButtonText_SeeAllArticles": "Zobraziť všetky články"
        },
        "HubertTip": {
            "Title": "Tip od Huberta",
            "Subtitle": "Rob pohovory rýchlejšie",
            "Description": "Uchádzaš sa o novú prácu v podobnej pozícii, pre ktorú si už predtým absolvoval Hubertov pohovor? Môžeš znovu použiť svoje odpovede a ušetriť čas.",
            "ButtonText_ReadMoreTips": "Prečítaj si viac tipov"
        },
        "NewCandidateModalPopup": {
            "Title": "Všetko je pripravené!",
            "DescriptionLine1": "Tvoj účet je pripravený.",
            "DescriptionLine2": "Spravuj svoje pohovory a profil. Pozri si výsledky, získaj spätnú väzbu a nauč sa viac o tom, ako absolvovať pohovory.",
            "ButtonText_LetsGo": "Poďme na to"
        },
        "InterviewCompletedModal": {
            "Title": "Skvelá práca!",
            "Subtitle": "Dokončil si svoj pohovor.",
            "Description": "Recruiteri prejdú všetky žiadosti a poskytnú spätnú väzbu e-mailom alebo telefonicky hneď, ako budú mať informácie.",
            "ButtonText_Continue": "Pokračovať"
        },
        "LatestJobPostings": {
            "Title": "Najnovšie pracovné ponuky",
            "Subtitle": "Preskúmaj ďalšie ponuky od partnerov Huberta, ktoré boli nedávno zverejnené."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Moje pohovory",
        "MyInterviewsSection_Subtitle": "Vyber si pohovor, aby si videl hodnotenie a svoje kariérne príležitosti.",
        "MyInterviewsSection_ToDo": "Na vybavenie"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Zobraziť všetky pohovory",
        "InterviewNotFound_Title": "Prístup odmietnutý",
        "InterviewNotFound_Description": "Pokúšaš sa získať prístup k detailom pohovoru, ktoré nie sú priradené k tvojmu účtu.",
        "ButtonText_GoToAllInterviews": "Prejsť na Moje pohovory",
        "InterviewDetails": {
            "Title": "Podrobnosti o pohovore",
            "ForRole": "Pre pozíciu",
            "InterviewCompletedOn": "Pohovor dokončený {{date}} o {{time}}"
        },
        "MyResult": {
            "Title": "Môj výsledok",
            "Subtitle": "Vyhodnotená zhoda",
            "ButtonText_LearnMore": "Pozri sa, ako Hubert hodnotí tvoje odpovede",
            "GotPotential_Title": "Má potenciál, chýba požiadavka",
            "GotPotential_Description": "Tvoje odpovede naznačujú silný potenciál pre tento typ roly. Avšak na základe tohto pohovoru nemusíš spĺňať jednu alebo viac kvalifikačných požiadaviek. To môže ovplyvniť ďalšie kroky v závislosti od potrieb náborára a počtu kandidátov. Ak nebudeš pozvaný do ďalšej fázy, neznamená to, že nemáš potenciál. Často ide o presné splnenie špecifických požiadaviek roly. Pozri si príležitosti a tipy nižšie.",
            "GotPotential_DescriptionSecondary": "Hubertovo hodnotenie je poradné. Náborár robí konečné rozhodnutie a výsledok môžu ovplyvniť aj iné faktory.",
            "GreatMatch_Title": "Silná zhoda",
            "GreatMatch_Description": "Tvoje odpovede sa dobre zhodovali s tým, čo náborári zvyčajne hľadajú, a spĺňaš požiadavky. Skvelá práca. Náborár prejde všetkých kandidátov a rozhodne o ďalších krokoch.",
            "GreatMatch_DescriptionSecondary": "Hubertovo hodnotenie je poradné. Náborár robí konečné rozhodnutie a výsledok môžu ovplyvniť aj iné faktory. Ak nebudeš pozvaný do ďalšej fázy, neznamená to, že nemáš potenciál. Často ide o presné splnenie špecifických požiadaviek roly. Pozri si príležitosti a tipy nižšie.",
            "OkMatch_Title": "Kvalifikovaný, zvýš dopad",
            "OkMatch_Description": "Spĺňaš požiadavky. Aby si vynikol, tvoje odpovede môžu potrebovať viac jasnosti a konkrétnosti. Pozri si svoje odpovede nižšie a zisti, kde pridanie konkrétneho príkladu alebo výsledku môže zvýšiť tvoje skóre.",
            "OkMatch_DescriptionSecondary": "Hubertovo hodnotenie je poradné. Náborár robí konečné rozhodnutie a výsledok môžu ovplyvniť aj iné faktory.",
            "NotClearMatch_Title": "Možno nie tá správna zhoda (zatiaľ)",
            "NotClearMatch_Description": "Na základe tohto pohovoru môžu byť tvoje odpovede menej v súlade s tým, čo náborár hľadá, alebo nespĺňaš niektoré požiadavky. Ak sa chceš zlepšiť, začni otázkami nižšie. Malé zmeny, viac konkrétnosti a jasné výsledky môžu nabudúce znamenať veľký rozdiel.",
            "NotClearMatch_DescriptionSecondary": "Hubertovo hodnotenie je poradné. Náborár robí konečné rozhodnutie a výsledok môžu ovplyvniť aj iné faktory."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Profesionálne skúsenosti, motivácie a kompetencie",
            "QualifyingRequirements": "Kvalifikačné požiadavky pre túto konkrétnu prácu",
            "NotQualified_Title": "Priestor na zlepšenie",
            "NotQualified_Description": "Tvoje odpovede mohli byť menej špecifické alebo zamerané na výsledky, než náborár očakáva. Pozri si nižšie zvýraznené miesta, kde pridanie konkrétneho príkladu, akcií alebo jasného výsledku môže posilniť tvoje odpovede.",
            "GreatResults_Title": "Silné odpovede",
            "GreatResults_Description": "Tvoje odpovede naznačujú, že sa hodíš na tento typ roly a komunikoval si jasne. Ak sa dá nejaká otázka vylepšiť, uvidíš ju zvýraznenú nižšie.",
            "MeetingRequirements_Title": "Spĺňanie požiadaviek",
            "MeetingRequirements_Description": "Tvoje odpovede naznačujú, že spĺňaš kvalifikačné požiadavky stanovené náborárom. Dobrý základ.",
            "NotAllExpectationsMet_Title": "Jedna alebo viac požiadaviek chýba",
            "NotAllExpectationsMet_Description": "Na základe tvojich odpovedí nemusíš spĺňať jednu alebo viac kvalifikačných požiadaviek, napríklad certifikáty, licencie, vzdelanie alebo roky praxe.",
            "ButtonText_FindOutPossibleReasons": "Zobraziť detaily"
        },
        "ScriptFromInterview": {
            "Title": "Prečítaj si celý pohovor",
            "ButtonText_SeeWholeTranscript": "Čítať pohovor",
            "ButtonText_DeleteInterview": "Zmazať pohovor",
            "Loading_Title": "Načítavam...",
            "Loading_Subtitle": "Počkaj chvíľu, načítavame prepis tvojho pohovoru."
        },
        "HowToImproveAtInterviews": {
            "Title": "Ako sa zlepšiť v pohovoroch",
            "Subtitle_Questions": "Tu sú niektoré otázky, kde by tvoja odpoveď mohla byť vylepšená.",
            "Subtitle_NoQuestions": "Neboli označené žiadne konkrétne odpovede. Tu sú najlepšie spôsoby, ako zvýšiť dopad pre túto rolu.",
            "GreatMatch_Questions_Description": "Aj keď si silná zhoda, niektoré odpovede sa dajú posilniť. Ak sme nejaké identifikovali, nájdeš ich nižšie. Postupuj podľa pokynov pred každou otázkou. Pri opise situácie uveď situáciu, čo si urobil a výsledok. Vyhni sa veľmi krátkym odpovediam. Snaž sa o jasné a konkrétne opisy.",
            "GreatMatch_NoQuestions_Description": "Pravdepodobne si odpovedal dobre na všetky otázky. Dobrá práca.",
            "OkMatch_Questions_Description": "Nižšie nájdeš otázky, kde by sa tvoja odpoveď dala zlepšiť. Postupuj podľa pokynov pred každou otázkou. Pri opise situácie uveď situáciu, čo si urobil a výsledok. Vyhni sa veľmi krátkym odpovediam. Snaž sa o jasné a konkrétne opisy.",
            "OkMatch_NoQuestions_Description": "Tvoje odpovede boli solídne, ale táto rola môže byť konkurenčná. To znamená, že aj dobré odpovede môžu skončiť v priemere.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Nabudúce sa zameraj na jasnosť a dopad. Začni výsledkom, pridaj jeden reálny príklad a buď stručný, zvyčajne 3 až 6 viet. Buď konkrétny v tom, čo si urobil, ako a čo sa vďaka tomu zmenilo.",
            "GotPotential_Questions_Description": "Aj keď vyzeráš ako silný kandidát, niektoré odpovede sa dajú posilniť. Ak sme nejaké identifikovali, nájdeš ich nižšie. Postupuj podľa pokynov pred každou otázkou. Pri opise situácie uveď situáciu, čo si urobil a výsledok. Vyhni sa veľmi krátkym odpovediam. Snaž sa o jasné a konkrétne opisy.",
            "GotPotential_NoQuestions_Description": "Nenašli sme žiadne odpovede, ktoré by potrebovali výrazné zlepšenie v oblasti kompetencií a motivácie. Zdá sa, že si odpovedal dobre.",
            "NotClearMatch_Questions_Description": "Nižšie nájdeš otázky, kde by sa tvoja odpoveď dala zlepšiť. Postupuj podľa pokynov pred každou otázkou. Pri opise situácie uveď situáciu, čo si urobil a výsledok. Vyhni sa veľmi krátkym odpovediam. Snaž sa o jasné a konkrétne opisy.",
            "NotClearMatch_NoQuestions_Description": "Nenašli sme jedinú „zlú“ odpoveď. Ide skôr o celkový súlad s potrebami roly. Ak je konkurencia silná, malé medzery môžu zavážiť.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Pri ďalšom pohovore sa sústreď na konkrétnosť. Vyber jeden príklad na otázku, vysvetli svoje kroky a zdieľaj výsledok. Krátke a špecifické je zvyčajne lepšie ako dlhé a všeobecné.",
            "Alert_WantMoreAdvice": "Chceš viac rád, ako uspieť v Hubertovom pohovore?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Preskúmaj náš článok so všeobecnými radami"
        },
        "SimilarOffers": {
            "Title": "Podobné ponuky"
        },
        "HowHubertScoresInterviews": {
            "Title": "Ako Hubert hodnotí pohovory?",
            "Description": "Nižšie je stručný opis, ako Hubert hodnotí odpovede. Pridali sme aj sekciu Náborový proces, ktorá vysvetľuje ďalšie kroky.",
            "Tabs_PossibleOutcomes": "Možné výsledky",
            "Tabs_RecruitmentProcess": "Náborový proces",
            "AssessedMatch_Title": "Vyhodnotená zhoda",
            "AssessedMatch_Description": "Hubert hodnotí, ako tvoje odpovede celkovo zodpovedajú očakávaniam náborárov. Spolu s požiadavkami roly uvidíš jeden z výsledkov nižšie.",
            "AssessedMatch_DescriptionSecondary": "Hubertovo hodnotenie je poradné. Náborár robí konečné rozhodnutie a výsledok môžu ovplyvniť aj iné faktory.",
            "GreatMatch_Title": "Silná zhoda",
            "GreatMatch_Description": "Tvoje odpovede sa dobre zhodujú s očakávaniami náborárov a spĺňaš požiadavky. Skvelá práca. Náborár prejde kandidátov a rozhodne o ďalších krokoch.",
            "GotPotential_Title": "Má potenciál, chýba požiadavka",
            "GotPotential_Description": "Tvoje odpovede naznačujú silný potenciál. Avšak nemusíš spĺňať jednu alebo viac kvalifikačných požiadaviek. To môže ovplyvniť ďalšie kroky.",
            "OkMatch_Title": "Kvalifikovaný, zvýš dopad",
            "OkMatch_Description": "Spĺňaš požiadavky. Aby si vynikol, tvoje odpovede môžu potrebovať viac jasnosti a konkrétnosti. Použi spätnú väzbu na posilnenie príkladov v budúcnosti.",
            "NotClearMatch_Title": "Možno nie tá správna zhoda (zatiaľ)",
            "NotClearMatch_Description": "Na základe tohto pohovoru môžu byť tvoje odpovede menej v súlade s očakávaniami a nemusíš spĺňať niektoré požiadavky. Pozri si odpovede, kde môžeš pridať jasnosť a príklady.",
            "ProfessionalExperiences_Title": "Profesionálne skúsenosti, motivácie a kompetencie",
            "ProfessionalExperiences_Description": "Otázky o tvojich predchádzajúcich skúsenostiach, motivácii a relevantných kompetenciách. Náborári rozhodujú, ktoré otázky sa použijú.",
            "GreatResults_Title": "Silné odpovede",
            "GreatResults_Description": "Tvoje odpovede naznačujú, že sa hodíš na tento typ roly a komunikoval si jasne. Ak sa dá otázka vylepšiť, uvidíš ju zvýraznenú.",
            "NotQualified_Title": "Priestor na zlepšenie",
            "NotQualified_Description": "Tvoje odpovede mohli byť menej špecifické alebo zamerané na výsledky. Hľadaj zvýraznené miesta, kde pridanie príkladu alebo výsledku môže posilniť tvoje odpovede.",
            "QualifyingRequirements_Title": "Základné alebo kvalifikačné požiadavky",
            "QualifyingRequirements_Description": "Otázky nastavené ako kvalifikačné požiadavky, napr. certifikát, vodičský preukaz alebo úroveň skúseností.",
            "MeetingRequirements_Title": "Spĺňanie požiadaviek",
            "MeetingRequirements_Description": "Tvoje odpovede naznačujú, že spĺňaš kvalifikačné požiadavky. Dobrý základ.",
            "NotAllExpectationsMet_Title": "Jedna alebo viac požiadaviek chýba",
            "NotAllExpectationsMet_Description": "Na základe tvojich odpovedí nemusíš spĺňať jednu alebo viac kvalifikačných požiadaviek pre túto prácu.",
            "RecruitmentProcess_Title": "Náborový proces",
            "RecruitmentProcess_Description": "Hubert sa zvyčajne používa ako prvý krok. Umožňuje každému absolvovať pohovor a vyjadriť sa. Keďže otázky sú rovnaké, proces je konzistentnejší. Hubert nepoužíva informácie ako vek, pohlavie alebo vzhľad, čím znižuje riziko zaujatosti.",
            "EventOne_Title": "Absolvuješ pohovor s Hubertom",
            "EventOne_Description": "Pohovor absolvuješ kedykoľvek a kdekoľvek ti to vyhovuje. Nie sú žiadne časové obmedzenia a môžeš si kedykoľvek urobiť prestávku.",
            "EventTwo_Title": "Tvoj pohovor je hodnotený",
            "EventTwo_Description": "Hubert hodnotí tvoje odpovede modernou technológiou. Hneď po dokončení sú výsledky viditeľné v My Hubert a pre náborára.",
            "EventThree_Title": "Náborár vyberá kandidátov",
            "EventThree_Description": "Náborári vidia, keď je v ich systéme dostupný nový výsledok. Môžu si pozrieť tvoje odpovede aj hodnotenie Huberta a rozhodnúť o ďalších krokoch. Ak sú iní kandidáti vhodnejší, tvoja žiadosť sa nemusí posunúť do ďalšej fázy.",
            "ButtonText_Close": "Zavrieť"
        }
    },
    "MyProfile": {
        "Title": "Môj profil",
        "MyDetails": {
            "Title": "Moje údaje",
            "Label_FirstName": "Meno",
            "Label_LastName": "Priezvisko",
            "Label_Email": "E-mail",
            "Label_PhoneNumber": "Telefónne číslo",
            "ButtonText_UpdateDetails": "Aktualizovať údaje",
            "Error_FirstName_Required": "Meno je povinné.",
            "Error_LastName_Required": "Priezvisko je povinné.",
            "Error_Email_Required": "E-mail je povinný.",
            "Error_Email_Invalid": "Zadajte platný e-mail.",
            "Error_PhoneNumber_Invalid": "Telefónne číslo nie je platné.",
            "Success_Details_Updated": "Profil aktualizovaný."
        },
        "ChangePassword": {
            "Title": "Zmeniť heslo",
            "Set_Password_Title": "Vytvoriť heslo",
            "Label_CurrentPassword": "Aktuálne heslo",
            "Label_NewPassword": "Nové heslo",
            "Label_RepeatNewPassword": "Zopakovať nové heslo",
            "Alert_SignInAgain": "Pre nastavenie hesla sa prihláste znova.",
            "ButtonText_UpdatePassword": "Aktualizovať heslo",
            "ButtonText_SetPassword": "Nastaviť heslo",
            "ButtonText_SignInAgain": "Prihlásiť sa znova",
            "Error_CurrentPassword_Required": "Aktuálne heslo je povinné.",
            "Error_CurrentPassword_DoesntMatch": "Heslo sa nezhoduje.",
            "Error_NewPassword_Required": "Nové heslo je povinné.",
            "Error_NewPassword_6_Characters": "Nové heslo musí mať aspoň 6 znakov.",
            "Error_RepeatNewPassword_Required": "Zopakovanie hesla je povinné.",
            "Error_RepeatNewPassword_DoesntMatch": "Heslo sa nezhoduje s novým heslom.",
            "Success_Password_Changed": "Heslo aktualizované.",
            "Error_Invalid_CurrentPassword": "Neplatné aktuálne heslo."
        },
        "NotificationPreferences": {
            "Title": "Nastavenia upozornení",
            "Label_ReceiveUpdatesToggle": "Chcem dostávať aktualizácie od Huberta.",
            "Label_ReceiveUpdatesToggleHelpText": "Budete dostávať kariérne príručky, tipy na pohovory a ďalšie."
        },
        "AccountRemoval": {
            "Title": "Odstránenie účtu",
            "ButtonText_RemoveMyAccount": "Odstrániť môj účet"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Ahoj",
        "Subtitle": "Chystáte sa začať pracovný pohovor.",
        "TipBox_Title": "Tu je niekoľko tipov na úspech.",
        "TipBox_Tip1": "Robte pohovor na pokojnom mieste, aby ste sa mohli sústrediť.",
        "TipBox_Tip2": "Odpovedajte na počítači s klávesnicou, ak je to možné.",
        "TipBox_Tip3": "Buďte čo najkonkrétnejší a najpodrobnejší. Hubert a náborári vás chcú spoznať.",
        "TipBox_Tip4": "Vezmite si čas, ktorý potrebujete. Nie sú tu žiadne časové limity.",
        "TipBox_Tip5": "Môžete si dať prestávku a pokračovať neskôr.",
        "TipBox_Tip6": "Buďte sami sebou a pristupujte k tomu ako k reálnemu pohovoru.",
        "CheckAdviceArticle_Text1": "Ak chcete viac tipov, ako uspieť na pohovore, pozrite si tento",
        "CheckAdviceArticle_Text2": "článok",
        "CheckAdviceArticle_Text3": "so skvelými radami.",
        "ReadyToGetStarted": "Ste pripravení začať?",
        "ORSeparator_Text": "Alebo",
        "ButtonText_StartInterviewNow": "Začať pohovor",
        "ButtonText_SetReminder": "Nie som pripravený, nastaviť pripomienku",
        "PrivacyPolicyText": "Stlačením začať pohovor súhlasíte so",
        "PrivacyPolicyLink": "Zásadami ochrany osobných údajov a Obchodnými podmienkami"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Skvelá práca!",
        "CompletedAlert_Subtitle": "Dokončili ste svoj pohovor.",
        "CompletedAlert_Description": "Náborári preskúmajú všetky žiadosti a poskytnú spätnú väzbu e-mailom alebo telefonicky, hneď ako budú mať informácie.",
        "InterviewNotCompleted": "Tento pohovor nie je dokončený."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centrum pomoci",
            "Subtitle": "Nájdite odpovede na najčastejšie otázky o Hubertovi.",
            "Label_Search": "hľadať často kladené otázky",
            "ButtonText_Search": "Hľadať"
        },
        "FAQSection": {
            "Tabs_All": "Všetko",
            "Tabs_AboutHubertInterview": "O pohovore Hubert",
            "Tabs_TechnicalSupport": "Technická podpora"
        },
        "StillHaveQuestion": {
            "Title": "Máte ešte otázku?",
            "Description": "Radi pomôžeme.",
            "DropUsAEmail": "Napíšte nám na hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Môžem absolvovať pohovor telefonicky?",
                    "a": "Hubert funguje iba cez chat. Ak máte zdravotné obmedzenie, kontaktujte priamo spoločnosť."
                },
                {
                    "q": "Môžem absolvovať pohovor v inom jazyku?",
                    "a": "Pri niektorých pohovoroch si môžete vybrať jazyk. Ak možnosť chýba, jazyk je pravdepodobne požiadavkou. Kontaktujte spoločnosť."
                },
                {
                    "q": "Budem penalizovaný za krátke odpovede?",
                    "a": "Nie, pokiaľ odpoviete primerane. Detaily však pomáhajú."
                },
                {
                    "q": "Môžem znovu použiť svoje odpovede?",
                    "a": "Áno, ak ste prihlásení v My Hubert a uchádzate sa o podobnú rolu."
                },
                {
                    "q": "Bude môj pohovor čítať človek?",
                    "a": "Áno, naši zákazníci manuálne kontrolujú pohovory."
                },
                {
                    "q": "Absolvoval som pohovor, čo teraz?",
                    "a": "Výsledky sa odošlú náborárovi. Ten rozhodne o ďalšom kroku (hovor, test, finálny pohovor)."
                },
                {
                    "q": "Mám otázku o ďalších krokoch, koho kontaktovať?",
                    "a": "Kontaktujte spoločnosť, kde ste sa uchádzali o prácu."
                },
                {
                    "q": "Ako zabezpečujete nezaujatosť?",
                    "a": "Hubert je konzistentný a nepozná vek, pohlavie ani vzhľad, čo znižuje zaujatosť."
                },
                {
                    "q": "Môžem byť pohovorovaný človekom?",
                    "a": "Kontaktujte spoločnosť s touto požiadavkou."
                },
                {
                    "q": "Je Hubert človek?",
                    "a": "Nie, je to počítačový systém."
                },
                {
                    "q": "Môžem zmeniť odpovede spätne?",
                    "a": "Nie, po odoslaní sa odpovede nedajú meniť."
                },
                {
                    "q": "Ako uspieť v pohovore?",
                    "a": "Čítajte pozorne, riaďte sa pokynmi, uvádzajte reálne príklady a buďte úprimní."
                },
                {
                    "q": "Potrebujem prácu, koho kontaktovať?",
                    "a": "Kontaktujte spoločnosť, kde ste sa uchádzali o prácu."
                },
                {
                    "q": "Po pohovore som nič nepočul. Čo robiť?",
                    "a": "O ďalších krokoch rozhodujú náborári. Čas odpovede závisí od tempa procesu a počtu kandidátov. Ak už prešiel nejaký čas, kontaktuj náborára a opýtaj sa na stav. V My Hubert si môžeš pozrieť svoje odpovede a tipy, čo nabudúce spresniť."
                },
                {
                    "q": "Mám skúsenosti, ale prácu som nedostal. Prečo?",
                    "a": "Často ide o presné dopasovanie k potrebám roly a porovnanie s inými kandidátmi, nie o konečný verdikt o tvojich schopnostiach. Ak môžeš, požiadaj firmu o krátku spätnú väzbu. V My Hubert nájdeš svoje odpovede a odporúčania, čo spraviť jasnejšie alebo konkrétnejšie nabudúce."
                },
                {
                    "q": "Ako dlho trvá pohovor?",
                    "a": "Medzi 10 a 25 minútami. Neponáhľajte sa."
                },
                {
                    "q": "Kde si prečítam o spracovaní údajov?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Prečo nevidím predchádzajúce pohovory?",
                    "a": "Uistite sa, že používate rovnaký e-mail ako pri žiadosti (vrátane Google prihlásenia)."
                },
                {
                    "q": "Prečo som nedostal e-mail?",
                    "a": "Skontrolujte spam. Alebo si vytvorte účet My Hubert s e-mailom zo žiadosti, aby ste našli odkaz."
                },
                {
                    "q": "Neviem nájsť odkaz v e-maile.",
                    "a": "Skontrolujte spam. Alebo sa prihláste do My Hubert a choďte do 'Moje pohovory'."
                },
                {
                    "q": "Funguje pohovor na mobile?",
                    "a": "Áno! Ale počítač môže byť pohodlnejší na písanie."
                },
                {
                    "q": "Pohovor nefunguje, čo robiť?",
                    "a": "Napíšte nám na hubert@hubert.ai."
                },
                {
                    "q": "Chcem zmazať účet, čo robiť?",
                    "a": "Napíšte nám na hubert@hubert.ai."
                },
                {
                    "q": "Pohovor bol prerušený, ako sa vrátiť?",
                    "a": "Kliknite na odkaz v e-maile alebo sa prihláste do My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Uč sa s Hubertom",
            "Subtitle": "Zistite, ako zvýšiť svoje šance a podávať lepší výkon.",
            "Label_Search": "hľadať príručky",
            "ButtonText_Search": "Hľadať"
        },
        "TabSelector": {
            "MyFeed": "Môj kanál",
            "InterviewGuides": "Príručky k pohovorom",
            "CareerGuides": "Kariérne príručky"
        },
        "NewestOnTheFeed": "Najnovšie",
        "PickedForMe": "Najnovšie články",
        "InterviewGuides": "Príručky k pohovorom",
        "CareerGuides": "Kariérne príručky"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Späť na všetky články"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Obnoviť heslo",
        "ResetLinkAlert_Subtitle": "Kliknite na odkaz v e-maile pre nastavenie nového hesla.",
        "PasswordNotSetAlert_Message": "Heslo nie je nastavené, prihláste sa cez",
        "ResetYourPassword": {
            "MainTitle": "Chcete vidieť výsledky pohovoru?",
            "Subtitle": "Prihláste sa pre výsledky, spätnú väzbu a viac.",
            "FormSectionTitle": "Obnoviť heslo",
            "Label_NewPassword": "Nové heslo",
            "Label_ConfirmNewPassword": "Potvrdiť nové heslo",
            "Error_NewPassword_Required": "Zadajte nové heslo.",
            "Error_Password_6_Characters": "Heslo musí mať aspoň 6 znakov.",
            "Error_ConfirmNewPassword_Required": "Musíte potvrdiť heslo.",
            "Error_ConfirmNewPassword_NotMatch": "Heslá sa nezhodujú.",
            "Error_MalformedResetUrl": "Neplatný bezpečnostný kód. Skúste znova.",
            "Error_ResetPasswordFailed": "Problém pri obnovení. Skúste znova.",
            "Error_WeakPassword": "Heslo musí mať aspoň 6 znakov.",
            "Error_InvalidCode_Title": "Žiadosť vypršala alebo je neplatná.",
            "Error_InvalidCode_Subtitle": "Skúste obnoviť heslo znova.",
            "ButtonText_SetNewPassword": "Nastaviť a prihlásiť sa",
            "ButtonText_RememberYourPassword": "Pamätáte si heslo?",
            "ButtonText_SignInInstead": "Prihlásiť sa"
        }
    },
    "PageNotFound": {
        "Title": "Stránka nenájdená",
        "Description": "Nevieme nájsť stránku, ktorú hľadáte.",
        "ButtonText_GoToDashboard": "Prejsť na Nástenku",
        "ButtonText_GoToLogin": "Prejsť na Prihlásenie"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Opätovné použitie odpovedí ešte nie je dostupné pre tento pohovor. Očakávame to čoskoro, ale pohovor môžete absolvovať teraz.",
        "DescriptionLine2": "Prejdite na pohovor kliknutím na tlačidlo nižšie.",
        "ButtonText_TakeMeToTheInterview": "Prejsť na pohovor"
    },
    "UnsubscribeFromEmails": {
        "Title": "Ste si istí?",
        "Subtitle": "Prestanete dostávať e-maily o tejto práci:",
        "SelectTheReason": "Vyberte dôvod.",
        "ReasonText1": "Našiel som si inú prácu.",
        "ReasonText2": "Už nemám záujem.",
        "ReasonText3": "Iné",
        "ButtonText_Unsubscribe": "Odhlásiť sa",
        "Placeholder_YourReason": "Váš dôvod",
        "Success_Title": "Úspešne ste sa odhlásili.",
        "Loading": "Načítavam...",
        "Error_YourReason_Required": "Zadajte dôvod.",
        "Error_ServerIssue": "Odhlásenie zlyhalo kvôli chybe servera."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Skúsiť znova"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidát sa nenašiel",
        "CandidateNotFoundDesc": "Nepodarilo sa nám nájsť podrobnosti o pohovore, ktoré hľadáte.",
        "InterviewEnded": "Pohovor ukončený",
        "InterviewEndedDesc1": "Táto relácia pohovoru skončila alebo už nie je k dispozícii.",
        "InterviewEndedDesc2": "Ďakujeme za váš čas. Ak máte akékoľvek otázky, kontaktujte náborový tím.",
        "ReadyTitle": "Ste pripravení na svoj pohovor, {{firstName}}?",
        "InvitationDesc": "Hubert vás v mene spoločnosti {{companyName}} pozýva na pohovor cez chat, ktorý trvá približne 1 – 2 minúty.",
        "Button_StartChat": "Spustiť četový pohovor",
        "CancelNotice": "Spustenie tu zruší naplánovaný hovor pre túto pozíciu.",
        "PreferNotToContinue": "Radšej by ste nepokračovali?",
        "DeclineLabel": "O túto pozíciu nemám záujem. Prosím, už ma v súvislosti s touto pozíciou nekontaktujte.",
        "Button_ConfirmAndDecline": "Potvrdiť a odmietnuť",
        "Processing": "Spracováva sa...",
        "Toast_DeclineSuccess": "Pohovor bol úspešne odmietnutý",
        "Toast_CancelVoiceInfo": "Hlasový pohovor zrušený. Funkcia bude čoskoro k dispozícii.",
        "Toast_CancelError": "Nepodarilo sa zrušiť pohovor. Skúste to znova.",
        "Footer_WithdrawConsent": "Svoj súhlas môžete kedykoľvek odvolať. Viac sa dozviete v ",
        "Footer_PrivacyPolicySuffix": " zásadách ochrany osobných údajov spoločnosti ",
        "Footer_And": " a v ",
        "Footer_HubertPrivacyLink": "zásadách ochrany osobných údajov a zmluvných podmienkach spoločnosti Hubert",
        "Chat_InterviewWith": "Pohovor so spoločnosťou {{companyName}}",
        "Chat_StatusConnected": "Pripojené",
        "Chat_StatusError": "Chyba",
        "Chat_StatusDisconnected": "Odpojené",
        "Chat_StatusConnecting": "Pripájanie...",
        "Chat_ReadyToStart": "Pripravení začať pohovor?",
        "Chat_ButtonStart": "Začať pohovor",
        "Chat_SayHello": "Pozdravte a začnite konverzáciu.",
        "Chat_EmptyState": "Pošlite správu a začnite pohovor.",
        "Chat_SelectLanguage": "Zvoľte si preferovaný jazyk",
        "Chat_Placeholder": "Napíšte svoju správu...",
        "Chat_ButtonSend": "Odoslať",
        "Chat_ButtonBack": "Späť",
        "LoadingCandidateDetails": "Načítavanie podrobností o kandidátovi...",
        "FetchingCandidateDetails": "Získavanie podrobností o kandidátovi...",
        "Chat_StatusReady": "Čakanie na pripojenie...",
        "Chat_ForbiddenError": "Tento četový pohovor už nie je k dispozícii.",
        "Chat_GeneralError": "Nepodarilo sa spustiť čet. Skúste to neskôr znova.",
        "Chat_SelectUiLanguage": "Jazyk rozhrania",
        "Chat_InterviewTitle": "Pracovný pohovor"
    }
}
